module.exports = __webpack_public_path__ + "img/3.535203a5.png";